import axios, { AxiosInstance, AxiosError } from 'axios';
import { config } from '../config';

// Экспортируем функцию обработки ошибок для использования в других модулях
export { getErrorMessage } from '../lib/errorHandling';

/**
 * Создание экземпляра axios для API запросов
 * Поддерживает как публичные, так и авторизованные запросы
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: config.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 секунд
});

/**
 * Интерцептор для добавления токена авторизации к запросам
 * Автоматически добавляет токен из localStorage, если он существует
 */
apiClient.interceptors.request.use(
  (config) => {
    // Получаем токен из localStorage
    const token = localStorage.getItem('app-web-auth-token');
    
    if (token) {
      // Добавляем токен в заголовок Authorization
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Интерцептор для обработки ошибок
 * Логирует ошибки в development режиме
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Логирование в development режиме
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
    }

    return Promise.reject(error);
  }
);
